/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class OutsourcedGameAssets {

    static WAYS_FONT = "NumbersWays";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_FS_MULTI = "Numbers_Multi";

    public static MAIN_GAME_BACKGROUND:string = "resources/images/Intro_BG.jpg";
    public static get MAIN_GAME_BACKGROUND_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(OutsourcedGameAssets.MAIN_GAME_BACKGROUND);
    }

    static IMAGES_LOGO:string = "resources/images/introLogo.png";
    static get IMAGES_LOGO_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(OutsourcedGameAssets.IMAGES_LOGO);
    }

    static BASE_GAME_BACKGROUND:string = "BG_Main"
    static FREESPINS_BACKGROUND:string = "BG_FS"
    static SUPER_FREESPINS_BACKGROUND:string = "BG_SFS"
    static MAX_WIN_ANTICIPATION:string = "MW_Anticipation/MW_Anticipation_";
    static REPLAY_CLICK:string = "Click/Click_";

    // spines
    static BIG_WIN_SPINE = "spine/Big_Win.json";
    static CONVEYOR_BELT = "spine/Conveyor_Spin.json";
    static FS_INTRO = "spine/FS_Intro.json";
    static SYM_WIN = "spine/SYM_Win.json";
    static XWAYS_SPINE = "spine/XW_Win.json";
    static MAX_WIN_SPINE = "spine/Max_Win.json";
    static CRASH_GAME_SPINE = "spine/Crash_Game.json";
    static X_NUDGE_SPINE = "spine/XN.json";
    static GOD_MODE_POPUP = "spine/Pop_Up_God_Mode.json";
    static LANDING_DUST = "spine/FX_Landing.json";
    static SCATTER = "spine/SC.json";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro:[],

        main:[
            {
                name:"fonts",
                assets:[
                    new BitmapFontAsset(OutsourcedGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(OutsourcedGameAssets.BITMAP_FONT_FS_MULTI, "fonts/bitmapfonts/Numbers_Multi.fnt"),
                    new BitmapFontAsset(OutsourcedGameAssets.WAYS_FONT, "fonts/bitmapfonts/NumbersWays.fnt"),
                ]
            },
            {
                name:"spine",
                assets:[
                    new SpineAsset(OutsourcedGameAssets.BIG_WIN_SPINE, OutsourcedGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(OutsourcedGameAssets.CONVEYOR_BELT, OutsourcedGameAssets.CONVEYOR_BELT),
                    new SpineAsset(OutsourcedGameAssets.FS_INTRO, OutsourcedGameAssets.FS_INTRO),
                    new SpineAsset(OutsourcedGameAssets.SYM_WIN, OutsourcedGameAssets.SYM_WIN),
                    new SpineAsset(OutsourcedGameAssets.XWAYS_SPINE, OutsourcedGameAssets.XWAYS_SPINE),
                    new SpineAsset(OutsourcedGameAssets.MAX_WIN_SPINE, OutsourcedGameAssets.MAX_WIN_SPINE),
                    new SpineAsset(OutsourcedGameAssets.CRASH_GAME_SPINE, OutsourcedGameAssets.CRASH_GAME_SPINE),
                    new SpineAsset(OutsourcedGameAssets.X_NUDGE_SPINE, OutsourcedGameAssets.X_NUDGE_SPINE),
                    new SpineAsset(OutsourcedGameAssets.GOD_MODE_POPUP, OutsourcedGameAssets.GOD_MODE_POPUP),
                    new SpineAsset(OutsourcedGameAssets.LANDING_DUST, OutsourcedGameAssets.LANDING_DUST),
                    new SpineAsset(OutsourcedGameAssets.SCATTER, OutsourcedGameAssets.SCATTER),
                ]
            },
            {
                name:"main",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                ],
                animations: {
                    [OutsourcedGameAssets.MAX_WIN_ANTICIPATION]: OutsourcedGameAssets.MAX_WIN_ANTICIPATION,
                    [OutsourcedGameAssets.REPLAY_CLICK]: OutsourcedGameAssets.REPLAY_CLICK,
                }
            },
            {
                name:"backgroundJpeg",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json"),
                    new TextureAsset("backgroundsJpeg4", "sheets/backgroundsJpeg/backgroundsJpeg4.json"),
                ],
            },
            {
                name:"mainJpeg",
                assets:[
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                ],
            },
            //{
            {
                name:"symbols",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations:{}
            }
        ]
    };

}
